// map-state.service.ts
import { computed, inject, Injectable, signal } from '@angular/core';
import { mapStyleMap, MapStyleType, SatelliteCountryService } from '@wheere-front/shared-map-libre';
import { Map } from 'maplibre-gl';

@Injectable({
  providedIn: 'root',
})
export class MapStateService {
  map = signal<Map | undefined>(undefined);

  mapStyleType = signal<MapStyleType>('street');
  /**
   * Pays du site affiché, qui décide du fournisseur satellite.
   *
   * <p>Délégué à un service racine partagé par toutes les cartes des deux applications. Chaque
   * bibliothèque a son propre service de carte, et laisser chacune porter son pays revenait à en
   * oublier une — c'est ce qui laissait des cartes en France sur un site tchèque. L'écran qui
   * charge un site ou un tracker le déclare une fois, et toutes les cartes suivent.
   */
  readonly country = inject(SatelliteCountryService).country;

  mapStyle = computed(() => mapStyleMap('D9ZvuUNhUV4ar033H5oD', this.country())[this.mapStyleType()]);

  public onToggleMapStyle() {
    this.mapStyleType.set(this.mapStyleType() === 'street' ? 'satellite' : 'street');
  }

  public removeLayers(layerIds: string[]) {
    const map = this.map();
    if (!map) return;

    layerIds.forEach(layerId => {
      if (map.getLayer(layerId)) {
        map.removeLayer(layerId);
      }
      if (map.getSource(layerId)) {
        map.removeSource(layerId);
      }
    });
  }

  public removeAllLayers(prefixes: string[]) {
    const map = this.map();
    if (!map) return;

    const layers = map.getStyle().layers || [];
    layers.forEach(layer => {
      if (prefixes.some(prefix => layer.id.startsWith(prefix))) {
        if (map.getLayer(layer.id)) {
          map.removeLayer(layer.id);
        }
        if (map.getSource(layer.id)) {
          map.removeSource(layer.id);
        }
      }
    });
  }

  flyTo(longitude: number, latitude: number) {
    this.map()?.flyTo({
      center: [longitude, latitude],
    });
  }
}
